import React from 'react';
import './SystemDetailsSubHeader.css';
import { setInactiveSystemVersionButton, setNotificationVisibility, setSystemInactiveFullScreenModal, setUploadSystemVersionFullScreenModal } from '../../modules/actions/action';
import { connect } from 'react-redux';

const UploadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 16V4m0 0L8 8m4-4 4 4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SystemDetailsSubHeader = (props) => {
  const channels = props.channels || [
    { value: 'Prod', label: 'Prod' },
    { value: 'Test', label: 'Dev' },
  ];

  return (
    <div className="system-detail-sub-header-container">
      <div className="system-detail-sub-header">
        <div className="system-detail-sub-header-heading">{props.heading || 'OTA Update Uploads'}</div>
        <div className="sub-header-buttons">
          <div className="ota-env-toggle">
            {channels.map((channel) => (
              <button
                key={channel.value}
                type="button"
                className={`ota-env-toggle-btn ${props.selectedEnv === channel.value ? 'ota-env-toggle-btn--active' : ''}`}
                onClick={() => props.onEnvChange(channel.value)}
              >
                {channel.label}
              </button>
            ))}
          </div>
          {props.showUpload !== false && (
            <button
              type="button"
              className="ota-upload-btn"
              onClick={() => props.openUploadSystemVersionModal()}
            >
              <UploadIcon />
              Upload
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  inactiveSystemIcon: state.inactiveSystemIcon.inactiveSystemVersionButton,
  showNotification: state.showNotification.showNotificatin,
  showUploadSystemVersionModal: state.uploadSystemVersionFullScreenModal.showUploadSystemVersionModal,
});

const mapDispatchToProps = (dispatch) => ({
  enableSystemVersionInactiveButton: () => { dispatch(setInactiveSystemVersionButton(true)); },
  disableSystemVersionInactiveButton: () => { dispatch(setInactiveSystemVersionButton(false)); },
  openSystemInactiveModal: () => { dispatch(setSystemInactiveFullScreenModal(true)); },
  closeSystemInactiveModal: () => { dispatch(setSystemInactiveFullScreenModal(false)); },
  closeNotification: () => { dispatch(setNotificationVisibility(false)); },
  openNotification: () => { dispatch(setNotificationVisibility(true)); },
  openUploadSystemVersionModal: () => { dispatch(setUploadSystemVersionFullScreenModal(true)); },
  closeUploadSystemVersionModal: () => { dispatch(setUploadSystemVersionFullScreenModal(false)); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SystemDetailsSubHeader);
